$(function () {
  const searchInput = $('.megamenu-search input[name="q"]');
  const loupeButton = $(".megamenu-search button");

  update();
  searchInput.on("input", update);

  function update() {
    const q = `${searchInput.val()}`.trim();
    loupeButton.prop("disabled", !q);
  }
});
